import styled from '@emotion/styled';
import { FC } from 'react';
import { Link, LinkProps } from 'react-router-dom';

import MobileLogo from 'app/components/MobileLogo';
import Logo, { LogoSize, LogoVariant } from 'app/components/shared/Logo';

// Local Typings
interface Props extends LinkProps {
  isMobile?: boolean;
  size?: LogoSize;
  variant?: LogoVariant;
}

// Local Variables
const StyledLink = styled(Link)({
  alignItems: 'center',
  display: 'flex',
});

// Component Definition
const LogoLink: FC<Props> = props => (
  <StyledLink to={props.to}>
    {props.isMobile
      ? <MobileLogo />
      : (
        <Logo
          size={props.size}
          variant={props.variant}
        />
      )}
  </StyledLink>
);

export default LogoLink;
